import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Login from './authentication/Login';
import getTheme from './theme/theme';
import Layout from './layout/Layout';
import Home from './pages/Home';
import Authhome from './authentication/Authhome';
import Register from './authentication/Register';
import ResetPassword from './authentication/ResetPassword';
import ResetPasswordForm from './authentication/ResetPasswordForm';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ConfirmRegistration from './authentication/Registrationconfirm';
//import Header from './layout/DrawerLayout';
import DailyLogsPage from './features/dailylogs/Dailylogs';
import ServiceticketsPage from './features/servicetickets/Servicetickets';
import HeaderLayout from './layout/HeaderLayout';
import UserAccountPage from './pages/useraccount/Useraccount';
import ProjectManagementPage from './Views/Management/ProjectManagement';
import CreateProjectPage from './Views/Management/CreateProjectPage';
import ProjectSchedule from './Views/Management/ProjectSchedule';
import ProjectScheduleEdit from './Views/Management/ProjectScheduleEdit';
import SubscriptionPlan from './pages/subscriptionplans/SunscriptionPlans';
import DailyLogEdit from './features/dailylogs/DailylogsEdit';
import CreateNewDailyLogPage from './features/dailylogs/DailylogsCreatenew';
import WorkOrdersPage from './features/workorders/Workorders';
import Features from './components/Features';
import SubscriptionPlans from './components/SubscriptionPlans';
import Contact from './components/Contact';
import ProtectedRoute from './ProtectedRoute';
import { Backdrop, CircularProgress, } from "@mui/material";
import axios from 'axios';
import { BASEURL } from "./constants/Common"
import UserRolePage from './pages/useraccount/Userrole';
import AddUserRolePage from './pages/useraccount/UserroleAddrole';
import ViewRolePage from './pages/useraccount/UserRoleEdit';
import DirectoryPage from './pages/useraccount/directory/directory';
import DirectoryAddUser from './pages/useraccount/directory/directoryadduser';
import SubscriptionMainPage from './pages/subscriptionplans/Subscription';
import SubscriptionPayment from './pages/subscriptionplans/Payment';
import PaymentSuccessfulpage from './pages/subscriptionplans/PaymentSuccessfulpage';
import AddUserPage from './pages/useraccount/adduser/Adduser';
import PaymentCancelPage from './pages/subscriptionplans/PaymentCancelPage';
import ProjectScheduleView from './Views/Management/ProjectScheduleView';
import EditOrModifyUserDetails from './pages/useraccount/adduser/ViewModifyAccount';
import AdminEditOrModifyUserDetails from './pages/useraccount/directory/AdminModify';
import UserSupportHomePage from './pages/usersupport/UserSupportHome';
import DemoVideosPage from './pages/usersupport/demovideo/DemoVideos';
import TrainingPage from './pages/usersupport/demovideo/training/Training';
import CreateTicketpage from './pages/usersupport/helpdesk/Helpdesk';
import IssueLogEdit from './pages/usersupport/helpdesk/IssueEdit';
import TrainingRegister from './pages/usersupport/demovideo/training/TrainingRegister';
//import ReportsMain from './pages/Reports/ReportsMain';
import CreateReport from './pages/Reports/CreateReport';
import ReportView from './pages/Reports/ReportView';
import Search from './features/search/Search';
import CreateNewServiceticketPage from './features/servicetickets/ServiceticketsCreatenew';
import ServiceticketEdit from './features/servicetickets/ServiceticketsEdit';
import ServiceticketView from './features/servicetickets/ServiceticketView';
import PunchlistsPage from './features/punchlists/Punchlists';
import CreateNewPunchlistPage from './features/punchlists/PunchlistsCreatenew';
import PunchlistView from './features/punchlists/PunchlistsView';
import PunchlistEdit from './features/punchlists/PunchlistsEdit';
import TodolistsPage from './features/todolists/Todolists';
import CreateNewTodolistPage from './features/todolists/TodolistsCreatenew';
import TodolistView from './features/todolists/TodolistsView';
import TodolistEdit from './features/todolists/TodolistsEdit';
import SafetylogsPage from './features/safetylogs/Safetylogs';
import CreateNewSafetylogPage from './features/safetylogs/SafetylogsCreatenew';
import SafetylogView from './features/safetylogs/SafetylogsView';
import SafetylogEdit from './features/safetylogs/SafetylogsEdit';
import InspectionsPage from './features/inspections/Inspections';
import CreateNewInspectionPage from './features/inspections/InspectionsCreatenew';
import InspectionView from './features/inspections/InspectionsView';
import InspectionEdit from './features/inspections/InspectionsEdit';
import VehiclelogsPage from './features/vehiclelogs/Vehiclelogs';
import CreateNewVehiclelogPage from './features/vehiclelogs/VehiclelogsCreatenew';
import VehiclelogView from './features/vehiclelogs/VehiclelogsView';
import VehiclelogEdit from './features/vehiclelogs/VehiclelogsEdit';
import CreateNewWorkordersPage from './features/workorders/WorkordersCreatenew';
import WorkorderEdit from './features/workorders/WorkordersEdit';
import WorkorderView from './features/workorders/WorkordersView';
import FreeTrialPage from './pages/subscriptionplans/SubscriptionFreetrial';
import SubscriptionHistoryPage from './pages/subscriptionplans/SubscriptionHistory';
import EmailVerification from './authentication/Emailverification';
import AutoLogout from './authentication/AutoLogout';
import InvoiceTemplate from './features/invoiceorder/Createinvoice';
import PreviewPage from './features/invoiceorder/Previewpage';
import InvoicesList from './features/invoiceorder/Invoicehistory';

interface ProjectNames {
  id: number;
  project_name: string;
  project_status: string;
}

const App = (): JSX.Element => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [projectNamesData, setProjectNamesData] = useState<ProjectNames[]>([]);
  const [visibleFlag, setVisibleFlag] = useState(true);   //To show hide Project Titles list in top bar
  const [multiSelectFlag, setMultiSelectFlag] = useState(false); //To allow multiple selection of Project title
  const [defaultProjectName, setDefaultProjectName] = useState('0');   //To set default selection in project Titles list in top bar
  const [isLoading, setIsLoading] = useState(false);

  const handleLogin = (token: string) => {
    localStorage.setItem('token', token);
    setIsLoggedIn(true);
    fetchProjectnamesList();
  };

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      setIsLoggedIn(true);
    }
  }, []);

  useEffect(() => {
    if (isLoggedIn) {
      fetchProjectnamesList();
    }
  }, [isLoggedIn]);

  const fetchProjectnamesList = async () => {
    setIsLoading(true);
    try {
      const orgid = localStorage.getItem('orgid');
      const userid = localStorage.getItem('authData');
      const pmlist_url = `${BASEURL}/projects/names/?orgid=${orgid}&userid=${userid}`;
      const response = await axios.get(pmlist_url, {
        headers: { Accept: 'application/json' },
      });

      const projectNames_list = response.data.project_names.filter(
        (project: ProjectNames) => project.project_status !== 'Deleted'
      );
      setProjectNamesData(projectNames_list);
      console.log(projectNames_list);
    } catch (error) {
      console.log(error);
    }
    setIsLoading(false);
  };

  const updateProjectnamesList = (newid: string, new_projname: string) => {
    try {
      //After creating new project, update the project names in header component
      const newProject: ProjectNames = {
        id: parseInt(newid),
        project_name: new_projname,
        project_status: ''
      };

      setProjectNamesData(prevProjectNames => [...prevProjectNames, newProject]);
      setDefaultProjectName(newid)
    } catch (error) {
      console.log(error);
    }
  };



  return (
    <HelmetProvider>
      <Helmet titleTemplate='%s | BRIX PRO' defaultTitle='BRIX PRO' />
      <ThemeProvider theme={getTheme()}>

        <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isLoading} >
          <CircularProgress color='inherit' />
        </Backdrop>

        <ToastContainer />
        <CssBaseline />
        <BrowserRouter>
          <Layout>
            {isLoggedIn && <AutoLogout />}
            <Routes> {/* Wrap all routes with <Routes> */}
              <Route path='/' element={<Home />} />
              <Route path='/login' element={<Login onLogin={handleLogin} />} />
              <Route path='/verifyemail' element={<EmailVerification />} />
              <Route path='/home' element={<Authhome />} />
              <Route path='/register' element={<Register />} />
              <Route path='/resetpassword' element={<ResetPassword />} />
              <Route path='/features' element={<Features />} />
              <Route path='/subscription' element={<SubscriptionPlans />} />
              <Route path='/contact' element={<Contact />} />
              <Route path='/password-reset/confirm/:uidb64/:token' element={<ResetPasswordForm />} />
              <Route path='/confirm/:uidb64/:token/:username' element={<ConfirmRegistration />} />
              <Route path='/subscriptionplans' element={<HeaderLayout projectName={projectNamesData} visibleFlag={visibleFlag} setDefaultProjectName={setDefaultProjectName}
                multiSelectFlag={multiSelectFlag} defaultProjectName={defaultProjectName}><SubscriptionPlan /></HeaderLayout>} />
              <Route path='/payment' element={<HeaderLayout projectName={projectNamesData} visibleFlag={visibleFlag} setDefaultProjectName={setDefaultProjectName}
                multiSelectFlag={multiSelectFlag} defaultProjectName={defaultProjectName}><PaymentSuccessfulpage /></HeaderLayout>} />
              <Route path='/subscriptions' element={<HeaderLayout projectName={projectNamesData} visibleFlag={visibleFlag} setDefaultProjectName={setDefaultProjectName}
                multiSelectFlag={multiSelectFlag} defaultProjectName={defaultProjectName}><SubscriptionMainPage /></HeaderLayout>} />
              <Route path='/subscriptions-freetrial' element={<HeaderLayout projectName={projectNamesData} visibleFlag={visibleFlag} setDefaultProjectName={setDefaultProjectName}
                multiSelectFlag={multiSelectFlag} defaultProjectName={defaultProjectName}><FreeTrialPage /></HeaderLayout>} />
              <Route path='/purchase' element={<HeaderLayout projectName={projectNamesData} visibleFlag={visibleFlag} setDefaultProjectName={setDefaultProjectName}
                multiSelectFlag={multiSelectFlag} defaultProjectName={defaultProjectName}><SubscriptionPayment /></HeaderLayout>} />
              <Route path='/subscriptionhistory' element={<HeaderLayout projectName={projectNamesData} visibleFlag={visibleFlag} setDefaultProjectName={setDefaultProjectName}
                multiSelectFlag={multiSelectFlag} defaultProjectName={defaultProjectName}><SubscriptionHistoryPage /></HeaderLayout>} />
              {/*  
              <Route path='/subscriptionplans' element={<HeaderLayout projectName={projectNamesData} visibleFlag={visibleFlag}
                  multiSelectFlag={multiSelectFlag} defaultProjectName={defaultProjectName}><SubscriptionPlan /></HeaderLayout>} />
              <Route path='/payment' element={<HeaderLayout projectName={projectNamesData} visibleFlag={visibleFlag}
                  multiSelectFlag={multiSelectFlag} defaultProjectName={defaultProjectName}><PaymentSuccessfulpage /></HeaderLayout>} />
              <Route path='/subscriptions' element={<HeaderLayout projectName={projectNamesData} visibleFlag={visibleFlag}
                  multiSelectFlag={multiSelectFlag} defaultProjectName={defaultProjectName}><SubscriptionMainPage/></HeaderLayout>} />
              <Route path='/purchase' element={<HeaderLayout projectName={projectNamesData} visibleFlag={visibleFlag}
                  multiSelectFlag={multiSelectFlag} defaultProjectName={defaultProjectName}><SubscriptionPayment /></HeaderLayout>} />
            {/*  <Route path='/createnewdailylog' element={<HeaderLayout><ProtectedRoute component={CreateNewDailyLogPage} /></HeaderLayout>} />
              <Route path='/dailylogs' element={<HeaderLayout><ProtectedRoute component={DailyLogsPage} /></HeaderLayout>} />
              <Route path='/log-details' element={<HeaderLayout><ProtectedRoute component={DailyLogEdit} /></HeaderLayout>} />
              <Route path='/view-role' element={<HeaderLayout><ProtectedRoute component={ViewRolePage} /></HeaderLayout>} />
              <Route path='/workorders' element={<HeaderLayout><WorkOrdersPage /></HeaderLayout>} />
  */        }

              <Route path='/createnewdailylog' element={
                <HeaderLayout projectName={projectNamesData} visibleFlag={visibleFlag}
                  setDefaultProjectName={setDefaultProjectName}
                  multiSelectFlag={multiSelectFlag} defaultProjectName={defaultProjectName}>
                  <ProtectedRoute component={CreateNewDailyLogPage} /></HeaderLayout>} />


              <Route path='/dailylogs' element={
                <HeaderLayout projectName={projectNamesData} visibleFlag={visibleFlag}
                  setDefaultProjectName={setDefaultProjectName}
                  multiSelectFlag={multiSelectFlag} defaultProjectName={defaultProjectName}>
                  <DailyLogsPage projectNameList={projectNamesData} /></HeaderLayout>} />

              <Route path='/log-details' element={
                <HeaderLayout projectName={projectNamesData} visibleFlag={visibleFlag}
                  setDefaultProjectName={setDefaultProjectName}
                  multiSelectFlag={multiSelectFlag} defaultProjectName={defaultProjectName}>
                  <ProtectedRoute component={DailyLogEdit} /></HeaderLayout>} />

              <Route path='/createnewserviceticket' element={
                <HeaderLayout projectName={projectNamesData} visibleFlag={visibleFlag}
                  setDefaultProjectName={setDefaultProjectName}
                  multiSelectFlag={multiSelectFlag} defaultProjectName={defaultProjectName}>
                  <ProtectedRoute component={CreateNewServiceticketPage} /></HeaderLayout>} />

              <Route path='/servicetickets' element={
                <HeaderLayout projectName={projectNamesData} visibleFlag={visibleFlag}
                  setDefaultProjectName={setDefaultProjectName}
                  multiSelectFlag={multiSelectFlag} defaultProjectName={defaultProjectName}>
                  <ServiceticketsPage projectNameList={projectNamesData} /></HeaderLayout>} />

              <Route path='/ticket-details' element={
                <HeaderLayout projectName={projectNamesData} visibleFlag={visibleFlag}
                  setDefaultProjectName={setDefaultProjectName}
                  multiSelectFlag={multiSelectFlag} defaultProjectName={defaultProjectName}>
                  <ProtectedRoute component={ServiceticketView} /></HeaderLayout>} />

              <Route path='/ticket-details-edit' element={
                <HeaderLayout projectName={projectNamesData} visibleFlag={visibleFlag}
                  setDefaultProjectName={setDefaultProjectName}
                  multiSelectFlag={multiSelectFlag} defaultProjectName={defaultProjectName}>
                  <ProtectedRoute component={ServiceticketEdit} /></HeaderLayout>} />

              <Route path='/createnewpunchlist' element={
                <HeaderLayout projectName={projectNamesData} visibleFlag={visibleFlag}
                  setDefaultProjectName={setDefaultProjectName}
                  multiSelectFlag={multiSelectFlag} defaultProjectName={defaultProjectName}>
                  <ProtectedRoute component={CreateNewPunchlistPage} /></HeaderLayout>} />

              <Route path='/punchlists' element={
                <HeaderLayout projectName={projectNamesData} visibleFlag={visibleFlag}
                  setDefaultProjectName={setDefaultProjectName}
                  multiSelectFlag={multiSelectFlag} defaultProjectName={defaultProjectName}>
                  <PunchlistsPage projectNameList={projectNamesData} /></HeaderLayout>} />

              <Route path='/punchlist-details' element={
                <HeaderLayout projectName={projectNamesData} visibleFlag={visibleFlag}
                  setDefaultProjectName={setDefaultProjectName}
                  multiSelectFlag={multiSelectFlag} defaultProjectName={defaultProjectName}>
                  <ProtectedRoute component={PunchlistView} /></HeaderLayout>} />

              <Route path='/punchlist-details-edit' element={
                <HeaderLayout projectName={projectNamesData} visibleFlag={visibleFlag}
                  setDefaultProjectName={setDefaultProjectName}
                  multiSelectFlag={multiSelectFlag} defaultProjectName={defaultProjectName}>
                  <ProtectedRoute component={PunchlistEdit} /></HeaderLayout>} />


              <Route path='/todolists' element={
                <HeaderLayout projectName={projectNamesData} visibleFlag={visibleFlag}
                  setDefaultProjectName={setDefaultProjectName}
                  multiSelectFlag={multiSelectFlag} defaultProjectName={defaultProjectName}>
                  <TodolistsPage projectNameList={projectNamesData} /></HeaderLayout>} />

              <Route path='/createnewtodolist' element={
                <HeaderLayout projectName={projectNamesData} visibleFlag={visibleFlag}
                  setDefaultProjectName={setDefaultProjectName}
                  multiSelectFlag={multiSelectFlag} defaultProjectName={defaultProjectName}>
                  <ProtectedRoute component={CreateNewTodolistPage} /></HeaderLayout>} />

              <Route path='/todolist-details' element={
                <HeaderLayout projectName={projectNamesData} visibleFlag={visibleFlag}
                  setDefaultProjectName={setDefaultProjectName}
                  multiSelectFlag={multiSelectFlag} defaultProjectName={defaultProjectName}>
                  <ProtectedRoute component={TodolistView} /></HeaderLayout>} />

              <Route path='/todolist-details-edit' element={
                <HeaderLayout projectName={projectNamesData} visibleFlag={visibleFlag}
                  setDefaultProjectName={setDefaultProjectName}
                  multiSelectFlag={multiSelectFlag} defaultProjectName={defaultProjectName}>
                  <ProtectedRoute component={TodolistEdit} /></HeaderLayout>} />

              <Route path='/inspections' element={
                <HeaderLayout projectName={projectNamesData} visibleFlag={visibleFlag}
                  setDefaultProjectName={setDefaultProjectName}
                  multiSelectFlag={multiSelectFlag} defaultProjectName={defaultProjectName}>
                  <InspectionsPage projectNameList={projectNamesData} /></HeaderLayout>} />

              <Route path='/createnewinspection' element={
                <HeaderLayout projectName={projectNamesData} visibleFlag={visibleFlag}
                  setDefaultProjectName={setDefaultProjectName}
                  multiSelectFlag={multiSelectFlag} defaultProjectName={defaultProjectName}>
                  <ProtectedRoute component={CreateNewInspectionPage} /></HeaderLayout>} />

              <Route path='/inspection-details' element={
                <HeaderLayout projectName={projectNamesData} visibleFlag={visibleFlag}
                  setDefaultProjectName={setDefaultProjectName}
                  multiSelectFlag={multiSelectFlag} defaultProjectName={defaultProjectName}>
                  <ProtectedRoute component={InspectionView} /></HeaderLayout>} />

              <Route path='/inspection-details-edit' element={
                <HeaderLayout projectName={projectNamesData} visibleFlag={visibleFlag}
                  setDefaultProjectName={setDefaultProjectName}
                  multiSelectFlag={multiSelectFlag} defaultProjectName={defaultProjectName}>
                  <ProtectedRoute component={InspectionEdit} /></HeaderLayout>} />


              <Route path='/createnewsafetylog' element={
                <HeaderLayout projectName={projectNamesData} visibleFlag={visibleFlag}
                  setDefaultProjectName={setDefaultProjectName}
                  multiSelectFlag={multiSelectFlag} defaultProjectName={defaultProjectName}>
                  <ProtectedRoute component={CreateNewSafetylogPage} /></HeaderLayout>} />

              <Route path='/safetylogs' element={
                <HeaderLayout projectName={projectNamesData} visibleFlag={visibleFlag}
                  setDefaultProjectName={setDefaultProjectName}
                  multiSelectFlag={multiSelectFlag} defaultProjectName={defaultProjectName}>
                  <SafetylogsPage projectNameList={projectNamesData} /></HeaderLayout>} />

              <Route path='/safetylog-details' element={
                <HeaderLayout projectName={projectNamesData} visibleFlag={visibleFlag}
                  setDefaultProjectName={setDefaultProjectName}
                  multiSelectFlag={multiSelectFlag} defaultProjectName={defaultProjectName}>
                  <ProtectedRoute component={SafetylogView} /></HeaderLayout>} />

              <Route path='/safetylog-details-edit' element={
                <HeaderLayout projectName={projectNamesData} visibleFlag={visibleFlag}
                  setDefaultProjectName={setDefaultProjectName}
                  multiSelectFlag={multiSelectFlag} defaultProjectName={defaultProjectName}>
                  <ProtectedRoute component={SafetylogEdit} /></HeaderLayout>} />

              <Route path='/createnewvehiclelog' element={
                <HeaderLayout projectName={projectNamesData} visibleFlag={visibleFlag}
                  setDefaultProjectName={setDefaultProjectName}
                  multiSelectFlag={multiSelectFlag} defaultProjectName={defaultProjectName}>
                  <ProtectedRoute component={CreateNewVehiclelogPage} /></HeaderLayout>} />

              <Route path='/vehiclelogs' element={
                <HeaderLayout projectName={projectNamesData} visibleFlag={visibleFlag}
                  setDefaultProjectName={setDefaultProjectName}
                  multiSelectFlag={multiSelectFlag} defaultProjectName={defaultProjectName}>
                  <VehiclelogsPage projectNameList={projectNamesData} /></HeaderLayout>} />

              <Route path='/vehiclelog-details' element={
                <HeaderLayout projectName={projectNamesData} visibleFlag={visibleFlag}
                  setDefaultProjectName={setDefaultProjectName}
                  multiSelectFlag={multiSelectFlag} defaultProjectName={defaultProjectName}>
                  <ProtectedRoute component={VehiclelogView} /></HeaderLayout>} />

              <Route path='/vehiclelog-details-edit' element={
                <HeaderLayout projectName={projectNamesData} visibleFlag={visibleFlag}
                  setDefaultProjectName={setDefaultProjectName}
                  multiSelectFlag={multiSelectFlag} defaultProjectName={defaultProjectName}>
                  <ProtectedRoute component={VehiclelogEdit} /></HeaderLayout>} />



              <Route path='/createproject' element={
                <HeaderLayout projectName={projectNamesData} visibleFlag={visibleFlag}
                  setDefaultProjectName={setDefaultProjectName}
                  multiSelectFlag={multiSelectFlag} defaultProjectName={defaultProjectName}>
                  <CreateProjectPage onUpdateProjectList={updateProjectnamesList} />
                </HeaderLayout>
              }
              />

              <Route path='/projmgmt' element={
                <HeaderLayout
                  projectName={projectNamesData} visibleFlag={visibleFlag}
                  setDefaultProjectName={setDefaultProjectName}
                  multiSelectFlag={multiSelectFlag} defaultProjectName={defaultProjectName}
                >
                  <ProtectedRoute component={ProjectManagementPage} /></HeaderLayout>} />

              <Route path='/projectschedule' element={
                <HeaderLayout projectName={projectNamesData} visibleFlag={true}
                  setDefaultProjectName={setDefaultProjectName}
                  multiSelectFlag={multiSelectFlag} defaultProjectName={defaultProjectName}>
                  <ProtectedRoute component={ProjectSchedule} /></HeaderLayout>}
              />

              <Route path='/viewSchedule' element={
                <HeaderLayout projectName={projectNamesData} visibleFlag={false}
                  setDefaultProjectName={setDefaultProjectName}
                  multiSelectFlag={multiSelectFlag} defaultProjectName={defaultProjectName}>
                  <ProtectedRoute component={ProjectScheduleView} /></HeaderLayout>}
              />

              <Route path='/useraccount' element={<HeaderLayout projectName={projectNamesData} visibleFlag={visibleFlag}
                setDefaultProjectName={setDefaultProjectName}
                multiSelectFlag={multiSelectFlag} defaultProjectName={defaultProjectName}>
                <ProtectedRoute component={UserAccountPage} /></HeaderLayout>} />

              <Route path='/userrole' element={<HeaderLayout projectName={projectNamesData} visibleFlag={visibleFlag}
                setDefaultProjectName={setDefaultProjectName}
                multiSelectFlag={multiSelectFlag} defaultProjectName={defaultProjectName}>
                <ProtectedRoute component={UserRolePage} /></HeaderLayout>} />

              <Route path='/adduserrole' element={<HeaderLayout projectName={projectNamesData} visibleFlag={visibleFlag} setDefaultProjectName={setDefaultProjectName}
                multiSelectFlag={multiSelectFlag} defaultProjectName={defaultProjectName}><ProtectedRoute component={AddUserRolePage} /></HeaderLayout>} />
              <Route path="/view-role/:id" element={<HeaderLayout projectName={projectNamesData} visibleFlag={visibleFlag} setDefaultProjectName={setDefaultProjectName}
                multiSelectFlag={multiSelectFlag} defaultProjectName={defaultProjectName}><ProtectedRoute component={ViewRolePage} /></HeaderLayout>} />
              <Route path="/view-role" element={<HeaderLayout projectName={projectNamesData} visibleFlag={visibleFlag} setDefaultProjectName={setDefaultProjectName}
                multiSelectFlag={multiSelectFlag} defaultProjectName={defaultProjectName}><ProtectedRoute component={ViewRolePage} /></HeaderLayout>} />
              <Route path='/adminedituserdetails' element={<HeaderLayout projectName={projectNamesData} visibleFlag={visibleFlag} setDefaultProjectName={setDefaultProjectName}
                multiSelectFlag={multiSelectFlag} defaultProjectName={defaultProjectName}><ProtectedRoute component={AdminEditOrModifyUserDetails} /></HeaderLayout>} />
              {/* <Route path="/view-role" element={<ViewRolePage />} /> */}
              <Route path='/directory' element={<HeaderLayout projectName={projectNamesData} visibleFlag={visibleFlag}
                setDefaultProjectName={setDefaultProjectName}
                multiSelectFlag={multiSelectFlag} defaultProjectName={defaultProjectName}><ProtectedRoute component={DirectoryPage} /></HeaderLayout>} />

              <Route path='/directoryadduser' element={<HeaderLayout projectName={projectNamesData} visibleFlag={visibleFlag}
                setDefaultProjectName={setDefaultProjectName}
                multiSelectFlag={multiSelectFlag} defaultProjectName={defaultProjectName}><ProtectedRoute component={DirectoryAddUser} /></HeaderLayout>} />

              <Route path='/adduser' element={<HeaderLayout projectName={projectNamesData} visibleFlag={visibleFlag}
                setDefaultProjectName={setDefaultProjectName}
                multiSelectFlag={multiSelectFlag} defaultProjectName={defaultProjectName}><ProtectedRoute component={AddUserPage} /></HeaderLayout>} />

              <Route path='/paymentcancel' element={<HeaderLayout projectName={projectNamesData} visibleFlag={visibleFlag}
                setDefaultProjectName={setDefaultProjectName}
                multiSelectFlag={multiSelectFlag} defaultProjectName={defaultProjectName}><ProtectedRoute component={PaymentCancelPage} /></HeaderLayout>} />
              <Route path='/editormodifyuser' element={<HeaderLayout projectName={projectNamesData} visibleFlag={visibleFlag} setDefaultProjectName={setDefaultProjectName}
                multiSelectFlag={multiSelectFlag} defaultProjectName={defaultProjectName}><ProtectedRoute component={EditOrModifyUserDetails} /></HeaderLayout>} />

              {/* usersupport routes */}

              <Route path='/usersupporthome' element={<HeaderLayout projectName={projectNamesData} visibleFlag={visibleFlag} setDefaultProjectName={setDefaultProjectName}
                multiSelectFlag={multiSelectFlag} defaultProjectName={defaultProjectName}><ProtectedRoute component={UserSupportHomePage} /></HeaderLayout>} />
              <Route path='/demovideos' element={<HeaderLayout projectName={projectNamesData} visibleFlag={visibleFlag} setDefaultProjectName={setDefaultProjectName}
                multiSelectFlag={multiSelectFlag} defaultProjectName={defaultProjectName}><ProtectedRoute component={DemoVideosPage} /></HeaderLayout>} />
              <Route path='/training' element={<HeaderLayout projectName={projectNamesData} visibleFlag={visibleFlag} setDefaultProjectName={setDefaultProjectName}
                multiSelectFlag={multiSelectFlag} defaultProjectName={defaultProjectName}><ProtectedRoute component={TrainingPage} /></HeaderLayout>} />
              <Route path='/ticket' element={<HeaderLayout projectName={projectNamesData} visibleFlag={visibleFlag} setDefaultProjectName={setDefaultProjectName}
                multiSelectFlag={multiSelectFlag} defaultProjectName={defaultProjectName}><ProtectedRoute component={CreateTicketpage} /></HeaderLayout>} />
              <Route path='/issueeditdetails' element={<HeaderLayout projectName={projectNamesData} visibleFlag={visibleFlag} setDefaultProjectName={setDefaultProjectName}
                multiSelectFlag={multiSelectFlag} defaultProjectName={defaultProjectName}><ProtectedRoute component={IssueLogEdit} /></HeaderLayout>} />
              <Route path='/trainingresource' element={<HeaderLayout projectName={projectNamesData} visibleFlag={visibleFlag} setDefaultProjectName={setDefaultProjectName}
                multiSelectFlag={multiSelectFlag} defaultProjectName={defaultProjectName}><ProtectedRoute component={TrainingRegister} /></HeaderLayout>} />

      /*
              <Route path='/reports' element={
                <HeaderLayout
                  projectName={projectNamesData} visibleFlag={visibleFlag}
                  setDefaultProjectName={setDefaultProjectName}
                  multiSelectFlag={multiSelectFlag} defaultProjectName={defaultProjectName}
                >
                  <ProtectedRoute component={CreateReport} /></HeaderLayout>} />
              */

              <Route path='/createreport' element={
                <HeaderLayout
                  projectName={projectNamesData} visibleFlag={visibleFlag}
                  setDefaultProjectName={setDefaultProjectName}
                  multiSelectFlag={multiSelectFlag} defaultProjectName={defaultProjectName}
                >
                  <ProtectedRoute component={CreateReport} /></HeaderLayout>} />

              <Route path='/viewreport' element={
                <HeaderLayout
                  projectName={projectNamesData} visibleFlag={visibleFlag}
                  setDefaultProjectName={setDefaultProjectName}
                  multiSelectFlag={multiSelectFlag} defaultProjectName={defaultProjectName}
                >
                  <ProtectedRoute component={ReportView} /></HeaderLayout>} />


              <Route path='/search' element={
                <HeaderLayout projectName={projectNamesData} visibleFlag={visibleFlag}
                  setDefaultProjectName={setDefaultProjectName}
                  multiSelectFlag={multiSelectFlag} defaultProjectName={defaultProjectName}>
                  <Search projectNameList={projectNamesData} /></HeaderLayout>} />




              <Route path='/workorders' element={
                <HeaderLayout projectName={projectNamesData} visibleFlag={visibleFlag}
                  setDefaultProjectName={setDefaultProjectName}
                  multiSelectFlag={multiSelectFlag} defaultProjectName={defaultProjectName}>
                  <WorkOrdersPage projectNameList={projectNamesData} /></HeaderLayout>} />


              <Route path='/createnewworkoder' element={
                <HeaderLayout projectName={projectNamesData} visibleFlag={visibleFlag}
                  setDefaultProjectName={setDefaultProjectName}
                  multiSelectFlag={multiSelectFlag} defaultProjectName={defaultProjectName}>
                  <ProtectedRoute component={CreateNewWorkordersPage} /></HeaderLayout>} />


              <Route path='/workorder-details-edit' element={
                <HeaderLayout projectName={projectNamesData} visibleFlag={visibleFlag}
                  setDefaultProjectName={setDefaultProjectName}
                  multiSelectFlag={multiSelectFlag} defaultProjectName={defaultProjectName}>
                  <ProtectedRoute component={WorkorderEdit} /></HeaderLayout>} />

              <Route path='/workorder-details' element={
                <HeaderLayout projectName={projectNamesData} visibleFlag={visibleFlag}
                  setDefaultProjectName={setDefaultProjectName}
                  multiSelectFlag={multiSelectFlag} defaultProjectName={defaultProjectName}>
                  <ProtectedRoute component={WorkorderView} /></HeaderLayout>} />

                  <Route path='/createinvoice' element={
                <HeaderLayout projectName={projectNamesData} visibleFlag={visibleFlag}
                  setDefaultProjectName={setDefaultProjectName}
                  multiSelectFlag={multiSelectFlag} defaultProjectName={defaultProjectName}>
                  <ProtectedRoute component={InvoiceTemplate} /></HeaderLayout>} />

                  <Route path='/invoice/preview' element={
                <HeaderLayout projectName={projectNamesData} visibleFlag={false}
                  setDefaultProjectName={setDefaultProjectName}
                  multiSelectFlag={multiSelectFlag} defaultProjectName={defaultProjectName}>
                  <ProtectedRoute component={PreviewPage} /></HeaderLayout>} />

                  <Route path='/invoicehistory' element={
                <HeaderLayout projectName={projectNamesData} visibleFlag={visibleFlag}
                  setDefaultProjectName={setDefaultProjectName}
                  multiSelectFlag={multiSelectFlag} defaultProjectName={defaultProjectName}>
                  <ProtectedRoute component={InvoicesList} /></HeaderLayout>} />

            </Routes>

          </Layout>
        </BrowserRouter>
      </ThemeProvider>
    </HelmetProvider >
  );
};

export default App;